import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { motion } from 'framer-motion';

import styles from './DimensionsImage.module.scss';

const cx = classNames.bind(styles);

const transition = {
	duration: 0.3,
	ease: [0.43, 0.13, 0.23, 0.96],
};

const lineVariants = {
    initial: { pathLength: 0 },
	show: { pathLength:  1, transition },
	hide: { pathLength: 0, transition },
};

const arrowVariants = {
    initial: {  opacity: 0 },
	show: {   opacity: 1, transition  },
	hide: {   opacity: 0 , transition },
}

const DimensionsImage = (props) => {
	const svgRef = React.useRef(null);

	const isVisible = (id) => id === props.visibleArrow;

	return (
		<div className={styles.wrapper}>
			<div className={styles.svgContainer}>
				<svg
					ref={svgRef}
					viewBox='0 0 128 176'
					fillRule='evenodd'
					clipRule='evenodd'
					strokeLinejoin='round'
					strokeMiterlimit='2'>
					<path
						d='M.5 27.92 20.48 14.6h93.24v133.2l-19.98 13.32H.5V27.92h93.24v133.2'
						fill='#f6f6f6'
						fillRule='nonzero'
						stroke='#000'
					/>
					<path fill='#ededed' stroke='#000' d='M13.82 41.24h66.6v119.88h-66.6z' />
					<path d='M47.12 161.12V41.24M93.74 27.92l19.98-13.32' fill='none' />

					<g
						id='arrow_height_of_cabin'
						className={cx(styles.svgArrow, { show: isVisible('height_of_cabin') })}
						fillRule='nonzero'>
						<motion.path
							d='M123.34 15.82v130.76'
							fill='none'
							stroke='#e00000'
							strokeWidth='1.5'
							strokeLinejoin='miter'
							strokeMiterlimit='4'
                            initial='initial'
                            variants={lineVariants}
                            animate={isVisible('height_of_cabin') ? 'show' : 'hide'}
						/>
						<motion.path
							d='m118.74 19.55.82.77 3.78-4.07 3.78 4.07.82-.77-4.6-4.95-4.6 4.95ZM118.74 142.85l.82-.77 3.78 4.07 3.78-4.07.82.77-4.6 4.95-4.6-4.95Z'
							fill='#e00000'
                            initial='initial'
                            variants={arrowVariants}
                            animate={isVisible('height_of_cabin') ? 'show' : 'hide'}
						/>
					</g>
					<g
						id='arrow_ht'
						className={cx(styles.svgArrow, { show: isVisible('height_of_cabin_door') })}
						fillRule='nonzero'>
						<motion.path
							d='M7.24 42.46V159.2'
							fill='none'
							stroke='#e00000'
							strokeWidth='1.5'
							strokeLinejoin='miter'
							strokeMiterlimit='4'
                            initial='initial'
                            variants={lineVariants}
                            animate={isVisible('height_of_cabin_door') ? 'show' : 'hide'}
						/>
						<motion.path
							d='m2.64 46.19.82.76 3.78-4.06 3.78 4.06.82-.76-4.6-4.95-4.6 4.95ZM2.64 155.47l.82-.76 3.78 4.06 3.78-4.06.82.76-4.6 4.95-4.6-4.95Z'
							fill='#e00000'
                            initial='initial'
                            variants={arrowVariants}
                            animate={isVisible('height_of_cabin_door') ? 'show' : 'hide'}
						/>
					</g>
					<g
						id='arrow_bt'
						className={cx(styles.svgArrow, { show: isVisible('width_of_cabin_door') })}
						fillRule='nonzero'>
						<motion.path
							d='M15.04 170.88H79.2'
							fill='none'
							stroke='#e00000'
							strokeWidth='1.5'
							strokeLinejoin='miter'
							strokeMiterlimit='4'
                            initial='initial'
                            variants={lineVariants}
                            animate={isVisible('width_of_cabin_door') ? 'show' : 'hide'}
						/>
						<motion.path
							d='m18.77 175.72.77-.82-4.07-3.78 4.07-3.78-.77-.82-4.95 4.6 4.95 4.6ZM75.47 175.72l-.77-.82 4.07-3.78-4.07-3.78.77-.82 4.95 4.6-4.95 4.6Z'
							fill='#e00000'
							transform='translate(0 -.24)'
                            initial='initial'
                            variants={arrowVariants}
                            animate={isVisible('width_of_cabin_door') ? 'show' : 'hide'}
						/>
					</g>

					<g
						id='arrow_width_of_cabin'
						className={cx(styles.svgArrow, { show: isVisible('width_of_cabin') })}
						fillRule='nonzero'>
						<motion.path
							d='M21.44 4.6h91.06'
							fill='none'
							stroke='#e00000'
							strokeWidth='1.5'
							strokeLinejoin='miter'
							strokeMiterlimit='4'
                            initial='initial'
                            variants={lineVariants}
                            animate={isVisible('width_of_cabin') ? 'show' : 'hide'}
						/>
						<motion.path
							d='m25.17 9.2.77-.82-4.06-3.78L25.94.82 25.17 0l-4.95 4.6 4.95 4.6ZM108.77 9.2l-.77-.82 4.07-3.78L108 .82l.77-.82 4.95 4.6-4.95 4.6Z'
							fill='#e00000'
                            initial='initial'
                            variants={arrowVariants}
                            animate={isVisible('width_of_cabin') ? 'show' : 'hide'}
						/>
					</g>

					<g
						id='arrow_depth_of_cabin'
						className={cx(styles.svgArrow, { show: isVisible('depth_of_cabin') })}
						fillRule='nonzero'>
						<motion.path
							d='m104.37 164.52 17.95-11.97'
							fill='none'
							stroke='#e00000'
							strokeWidth='1.5'
							strokeLinejoin='miter'
							strokeMiterlimit='4'
                            initial='initial'
                            variants={lineVariants}
                            animate={isVisible('depth_of_cabin') ? 'show' : 'hide'}
						/>
						<motion.path
							d='m113.41 162.2.18-1.11-5.48-.89 1.29-5.39-1.1-.26-1.56 6.57 6.67 1.08ZM125.15 154.37l-1.09-.26 1.28-5.39-5.47-.89.18-1.11 6.67 1.08-1.57 6.57Z'
							fill='#e00000'
							transform='translate(-3.38 4.08)'
                            initial='initial'
                            variants={arrowVariants}
                            animate={isVisible('depth_of_cabin') ? 'show' : 'hide'}
						/>
					</g>

					<path
						d='m93.74 27.92 19.98-13.32M47.12 41.24v119.88'
						fill='none'
						stroke='#000'
						strokeLinecap='round'
						strokeMiterlimit='1.5'
					/>
				</svg>
			</div>
		</div>
	);
};

DimensionsImage.propTypes = {
	visibleArrow: PropTypes.string.isRequired,
};

export default DimensionsImage;
